import { Box } from '@drivekyte/ui';

type DividerProps = {};

const Divider = ({}: DividerProps) => {
  return <Box width={1} height={32} backgroundColor="$borderDefault" />;
};

export default Divider;
